export default __webpack_public_path__ + "static/expressjs-903fb3fe9535c0e379270d4c9d2c2947.webp";